import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, getMyAuth } from 'src/app/store/app.state';
import { take } from 'rxjs/operators';
import { Utente } from '../models/utente.model';

/**Pure pipe che verifica se una cella della tabella glossari è editabile */
@Pipe({
  name: 'editableGlossary'
})
export class EditableGlossaryPipe implements PipeTransform {
  /**
   * Costruttore per la classe EditableGlossaryPipe
   * @param store {Store<AppState>} Stato a livello dell'applicazione
   */
  constructor(private store: Store<AppState>) { }

  /**
   * Metodo dell'interfaccia PipeTransform che effettua le operazioni del caso
   * @param voceGlos {Glossary} voce di glossario in esame
   * @returns {boolean}
   */
  transform(voceGlos: any, ...args: any[]): any {
    let editableResult: boolean = false;
    let noConditionEditRoles = ['Administrator', 'Supervisor', 'Publisher', 'Revisor'];
    if (!voceGlos.locked) { //se la risorsa non è bloccata
      let loggedUser: Utente;
      this.store.select(getMyAuth).pipe(take(1)).subscribe(data => {
        loggedUser = data.loggedUser;
      })
      if (loggedUser.type === 'Translator' && voceGlos.username === loggedUser.username) { //se l'utente loggato è un traduttore ed è l'autore della voce
        editableResult = true;
      } else if (noConditionEditRoles.indexOf(loggedUser.type) !== -1) {
        editableResult = true;
      }
    }
    return editableResult;
  }

}
